var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectrLocks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    fill: "url(#pattern19)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern19",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_70_936",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_70_936",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACxQAAAsUBidZ/7wAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAPmSURBVHic7dvPSxRhHMfx76zTjhvZKtqqRHYr0kth2yFaWi+Bx0Tq0h/QMYIuXbpVh+gqeQy7SdcgJIMVQkQqySJqo7AIUcxU0tUdnw79sJDd1Wdm9pmdz+d1E/dpvzBvd7XvjqWUkkCMZbJiqdGS31dWj5zJPQ3V2aF05bOXJsJ11qNYEP8o1Q4GAI4BgGMA4BgAOAYAjgGAYwDgGAA4BgCOAYBjAOAYADgGAM7ysg7u6pOAdsnVszY3bHoEz/K5fkv3LF8BwDEAcAwAHAMAxwDAMQBwtoxlsvrHc74NQh4MpbO6R+2yH0em2uDhGvItABwDAMcAwDEAcAwAHAMAZ4uyejyc1/7z41uvh2f1UeJdv+kRfnnmYS3t4RraJW+V3om72ifJTx5uHedbADgGAI4BgGMA4BgAOK6Do4DrYHBcB5MuBgCOAYBjAOAYADgGAM7YOph8xHUwOK6DSRcDAMcAwGEH4BZEFVdNT2GUbXqAaqtb+CDO8wdiz05LbP69vJl+IfGWLnHa0pJMX5V4c6fpEasKZh1sKVfik/clMT4o4q5vfUO5sj43JetzU7LyekiaTt+Q5KlrYsVq6GeD6+DKEqO3Jf7qYdnHKLcgC7nrUlz6KC3n7lVpMh9wHVyePTNe8eL/a+nloKx+GglwovCACCDx5Oauz8w/vhzAJOET+QBiy7NS9/3zrs9tLOaluDwTwEThEvkA6mantc8Wvk74OEk4RT8AjZ/+PzYW8z5OEk6RD8BtaNM+a+/v8HGScIr8OthNHdU+67Se8HGSAHEdXNpm42EpHuwW+8vkrs7VHzore5qOBDSVz7gOLm81c0VUfN+OHx9zktKcvRPgROEBEYCb6pSVvgFRTkPFx8acRmm/MCJO28kqTGYeRAAivyM4P1D2lSDmJKX9Is7FFwEKQETETR0T90DpXwrjqePitHZXcSLzoAKg7WDWwZHGdTA4roNJFwMAxwDAMQBwDAAcAwAX+XUwBK6DwXlYB9fQ3Q/++NF7S8Qt/P264+3WTSKWXW9iJKPgAtjc2/zf107S0CAhwV8CwTEAcAwAHNfBUcB1MDiug0kXAwDHAMAxAHAMABwDAMd1cBRwHQyOdweTLgYAjgGAYwDgGAA4roOjoBbXwU2PTDzrdmtzw6ZH8I7rYNLFAMAxAHAMABwDAMcAwHEdHAUerqGllNJ+3q4+0T8cElH4f4B8rt/SPcu3AHAMABwDAMcAwDEAcAwAnKc/A8say2TLrimV1VPyE8mmzg6lK58t9QlcU2c94isAOAYAjgGAYwDgGAA4BgCOAYBjAOAYADgGAI4BgGMA4BgAOAYA7icwTCUNO17k5gAAAABJRU5ErkJggg=="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrLocks);
export default __webpack_public_path__ + "static/media/electr-locks.cd8d37b01b4047f13b29a173aa172b9f.svg";
export { ForwardRef as ReactComponent };